export enum TipoHistoricoEnum {
  Baixo = 'baixo',
  Moderado = 'moderado',
	Elevado = 'elevado'
}